var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-editor-wrapper",class:{ loading: _vm.loading, 'icon-error': !_vm.loading && (!_vm.note || _vm.note.error), 'is-mobile': _vm.isMobile }},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.loading),expression:"!loading"}],ref:"editor",staticClass:"text-editor"})])
}
var staticRenderFns = []

export { render, staticRenderFns }